var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('span',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.title))]),_c('span',{attrs:{"id":"dimensions"}},[_vm._v(_vm._s(_vm.dimensions))])])
}
var staticRenderFns = []

export { render, staticRenderFns }